import Assignment from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import AirlineSeatFlatIcon from '@material-ui/icons/AirlineSeatFlat';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { SiMicrosoftexcel } from 'react-icons/si';

import MeusPedidosResidentes from 'views/MeusPedidosResidentes/MeusPedidosResidentes';
import Login from 'views/Login/Login';
import MeusPedidos from 'views/MeusPedidos/MeusPedidos';
import MinhasDemandas from 'views/MinhasDemandas/MinhasDemandas';
import AgendaMedico from 'views/AgendaMedico/AgendaMedico';
import Rastreamento from 'views/Rastreamento/Rastreamento';
import PedidosCirurgia from 'views/PedidosCirurgia/PedidosCirurgia';
import CheckListGeral from 'views/CheckListGeral/CheckListGeral';
import Dashboard from 'views/Dashboard/NovoDashboard';
import AgendaAreaTecnica from 'views/AgendaAreaTecnica/AgendaAreaTecnica';
import PareceresAreaTecnica from 'views/PareceresAreaTecnica/PareceresAreaTecnica';
import AvisoAtualizacaoOpera from 'views/AvisoAtualizacaoOpera/AvisoAtualizacaoOpera';
import Demandas from 'views/Demandas/Demandas';
import RelatorioDemandaCirurgica from 'views/RelatorioDemandaCirurgica/RelatorioDemandaCirurgica';
import MapaDeSalas from 'views/MapaDeSalas/MapaDeSalas';

const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: Dashboard,
    layout: '/admin',
  },
  {
    path: '/meusPedidos',
    name: 'Meus Pedidos',
    icon: ShoppingBasketIcon,
    component: MeusPedidos,
    layout: '/admin',
  },
  {
    path: '/minhasDemandas',
    name: 'Minhas Demandas',
    icon: ShoppingBasketIcon,
    component: MinhasDemandas,
    layout: '/admin',
  },
  {
    path: '/pedidosResidentes',
    name: 'Pedidos de Residentes',
    icon: ShoppingBasketIcon,
    component: MeusPedidosResidentes,
    layout: '/admin',
  },
  {
    path: '/agendaMedico',
    name: 'Agenda do Médico',
    icon: DateRangeIcon,
    component: AgendaMedico,
    layout: '/admin',
  },
  {
    path: '/mapaDeSalas',
    name: 'Mapa de Salas',
    icon: DateRangeIcon,
    component: MapaDeSalas,
    layout: '/admin',
  },
  {
    path: '/pedidosCirurgia',
    name: 'Pedidos de Cirurgia',
    icon: AirlineSeatFlatIcon,
    component: PedidosCirurgia,
    layout: '/admin',
  },
  {
    path: '/demandas',
    name: 'Demandas',
    icon: AirlineSeatFlatIcon,
    component: Demandas,
    layout: '/admin',
  },
  {
    path: '/checkListGeral',
    name: 'Checklist',
    icon: Assignment,
    component: CheckListGeral,
    layout: '/admin',
  },
  {
    path: '/pareceresAreaTecnica',
    name: 'Parecer Área Técnica',
    icon: Assignment,
    component: PareceresAreaTecnica,
    layout: '/admin',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    layout: '/auth',
  },
  {
    path: '/rastreamento/:codigoPedido',
    name: 'Rastreamento',
    component: Rastreamento,
    layout: '/auth',
  },
  {
    path: '/agendaAreaTecnica',
    name: 'Minha Agenda',
    icon: DateRangeIcon,
    component: AgendaAreaTecnica,
    layout: '/admin',
  },
  {
    path: '/relatorioDemandaCirurgica',
    name: 'Relatórios',
    icon: SiMicrosoftexcel,
    component: RelatorioDemandaCirurgica,
    layout: '/admin',
  },
  {
    path: '/avisoAtualizacaoOpera',
    name: 'Aviso de Atualizacao',
    component: AvisoAtualizacaoOpera,
    layout: '/auth',
  },
];

export default dashboardRoutes;
